module.exports = __webpack_public_path__ + "static/media/supveto.36f9609c.jpg";